import { PixelCrop, Dimensions } from "../customTypings/branding/crop";

const createImage = (url: string): Promise<CanvasImageSource> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

async function getCroppedImg(imageSrc: string, pixelCrop: PixelCrop, dims: Dimensions) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = dims.width;
  canvas.height = dims.height;
  if (ctx) {
    ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        canvas.width,
        canvas.height
    );
  }

    return canvas.toDataURL('image/png');
}

export const cropImage = async (image: string, croppedAreaPixels: PixelCrop, dims: Dimensions) => {
  try {
    const croppedImage = await getCroppedImg(image, croppedAreaPixels, dims);
    return croppedImage;
  } catch (err) {
    console.error(err);
  }
};

